import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const VisualDirectionLayout = lazy(() =>
  import(
    "@/features/brands/edit/components/visual-direction/VisualDirectionLayout"
  ).then((m) => ({ default: m.VisualDirectionLayout })),
);

export const Route = createFileRoute(
  "/_auth/_app-shell/brands/$brandId/visualdirection",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { brandId } = Route.useParams();

  return (
    <Suspense
      fallback={
        <div className="flex items-center justify-center py-16">
          Loading...
        </div>
      }
    >
      <VisualDirectionLayout brandId={Number(brandId)} />
    </Suspense>
  );
}
